import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { TopNav } from '../components/TopNav';
import { PlayerAvatar } from '../components/PlayerAvatar';
import { useGame } from '../state/gameContext';
import { getWinner } from '../state/mockGameReducer';
import { playSound } from '../state/soundManager';

export default function RoundWinnerPage() {
  const { state, currentPlayer, nextRound, runtimeMode } = useGame();
  const winner = getWinner(state);
  const result = state.lastRoundResult;
  const canAdvance = state.canAdvance ?? Boolean(currentPlayer?.isHost);
  const autoAdvances = runtimeMode === 'server';
  useEffect(() => { playSound('winner'); }, []);
  if (!result || !winner) return <Navigate to="/game" replace />;
  if (state.phase === 'gameOver') return <Navigate to="/game-over" replace />;

  return <div className="round-result-screen">
    <TopNav showChat />
    <main className="round-result-layout">
      <section className="round-result-content" aria-label="Round result" tabIndex={0}>
        <header className="round-result-heading">
          <p className="table-eyebrow">Round {state.roundNumber} / The table has spoken</p>
          <div className="round-result-winner">
            <PlayerAvatar initials={winner.initials} gradient={winner.gradient} size="md" alt={`${winner.name} avatar`} />
            <div><h1 data-testid="round-winner-name">{winner.name}</h1><p>{currentPlayer?.id === winner.id ? 'That one was yours. Nicely played.' : 'Wins the round.'}</p></div>
            <span className="round-result-point">+1<span>point</span></span>
          </div>
        </header>

        <div className="winning-pair">
          <article className="winning-prompt">
            <span className="table-eyebrow">The setup</span>
            <p>{result.promptText}</p>
            <span className="winning-card-footer">Deck After Dark / Prompt</span>
          </article>
          <article className="winning-answer">
            <span className="table-eyebrow">The winning answer</span>
            <p>{result.answerText}</p>
            <span className="winning-card-footer">Played by {winner.name}</span>
          </article>
        </div>

        <div className="round-result-score">
          <p><strong>{winner.score}</strong> {winner.score === 1 ? 'point' : 'points'} for {winner.name}</p>
          <span>First to {state.settings.pointsToWin} wins the game</span>
        </div>
      </section>
      <footer className="round-result-actions">
        <p data-testid={autoAdvances ? 'next-round-countdown' : undefined}>
          {autoAdvances ? 'The next round starts automatically.' : canAdvance ? 'Ready for another round?' : 'Waiting for the host to deal the next round.'}
        </p>
        {canAdvance && <button type="button" onClick={nextRound} data-testid="next-round" className="table-button">Next round <span aria-hidden="true">→</span></button>}
      </footer>
    </main>
  </div>;
}
